import DataTableContainer from '../data-table-container';
import RmRecsTable from '../tables/rm_recs/rm-recs-table';

function RmRecs() {
  return (
    <DataTableContainer>
      <RmRecsTable />
    </DataTableContainer>
  );
}

export default RmRecs;
